<div class="dialog-container" [class.form]="isForm" [ngClass]="type">
    <div mat-dialog-title *ngIf="!data.disableHeader" class="title">
        <h2>{{data.title}}</h2>
    </div>

    <button mat-button class="close" mat-dialog-close class="close" (click)="close()" (keydown.enter)="close()">
        <mat-icon>close</mat-icon>
    </button>

    <div mat-dialog-content class="content" *ngIf="data.content">
        {{data.content}}
    </div>

    <div mat-dialog-actions class="bottom" *ngIf="!data.disableFooter">
        <div *ngIf="!getIsHavingButtonEvents(data.acceptText,data.rejectText)">
            <a mat-button class="text-button" color="primary" disableRipple mat-dialog-close (click)="close()">{{data.bntLink}}</a>
            <button mat-flat-button color="primary" mat-dialog-close (click)="close()">{{data.bntPrimary}}</button>
        </div>
        <div class="dialog-footer" *ngIf="getIsHavingButtonEvents(data.acceptText,data.rejectText)">
            <button 
                class="accept-button" 
                mat-flat-button 
                color="{{data.acceptCssClass}}"
                [disabled]="data.disableAccept"
                (click)="onAccept()" *ngIf="data.acceptText?.length > 0"
                mat-dialog-close>
                {{data.acceptText}}
            </button>
            <button 
                class="cancel {{data.rejectCssClass}}"
                color="link" mat-stroked-button
                [disabled]="data.adminActionLoading"
                (click)="onReject()" *ngIf="data.rejectText?.length > 0"
                mat-dialog-close>
                {{data.rejectText}}
            </button>
        </div>
    </div>
</div>

